import Vue from 'vue'
import InnerImageZoom from 'vue-inner-image-zoom';

Vue.component('InnerImageZoom', InnerImageZoom);